import { Controller } from "@hotwired/stimulus";
import { initDropzone, initDropzoneBasicEvents, handleDropzoneUploadSuccess } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["filePreviewsContainer", "uploadImgLabel", "dragAndDropContainer"];

  connect() {
    this._initDropzone();
  }

  validateSubmission(e) {
    e.preventDefault();

    const formValid = $(this.element).parsley().validate();
    if (formValid) {
      this._submitForm(this.element);
    }
  }

  _submitForm(form) {
    if (this._isMandateFileAdded()) {
      this.dropzone.processQueue();
    } else {
      Rails.fire(form, "submit");
    }
  }

  _isMandateFileAdded() {
    return this.dropzone.getQueuedFiles().length !== 0;
  }

  _initDropzone() {
    const uploadOptions = {
      previewsContainer: this.filePreviewsContainerTarget,
      paramName: this.element.dataset.fileParamName,
    };
    this.dropzone = initDropzone(this.element.id, {}, uploadOptions);
    initDropzoneBasicEvents(this.dropzone, this.uploadImgLabelTarget, this.dragAndDropContainerTarget);
    handleDropzoneUploadSuccess(this.dropzone, this.element);
  }
}
